import axios from 'axios'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Button from 'src/components//button/Button'
import Checkbox from 'src/components//checkbox/Checkbox'
import Header from 'src/components//header/Header'
import Input from 'src/components//input/Input'
import ToggleSwitch from 'src/components//toggleSwitch/ToggleSwitch'
import SubHeader from 'src/components/subHeader/SubHeader'
import { IAttributes, Ipropeties, IState, ParamTypes } from 'src/Interface'
import useCancellablePromise from 'src/utils/useCancellablePromise'
import { baseApiURL } from 'src/utils/utils'
import { DispatchContext, StateContext } from '../../AppContext'
import styles from './booking-module.module.scss'

type ICategory = 'customerFields' | 'detailFields' | 'attributes'
type IType = 'fields' | 'attributes'
interface IAside {
  isShown: boolean
  category: ICategory
  type: IType
}

const BookingModule: React.FunctionComponent = () => {
  const [aside, toggleAside] = useState<IAside>({ isShown: false, category: null, type: null })
  const [isActive, setActive] = useState(false)
  const [referenceName, setReferenceName] = useState('Reference')
  const state: IState = useContext(StateContext)
  const history = useHistory()
  const location: any = useLocation()
  const [buttonLoading, setButtonLoading] = useState(false)
  const [loading, setLoading] = useState(true)
  const [focused, setFocused] = useState(false)
  const dispatch: any = useContext(DispatchContext)
  const { cancellablePromise } = useCancellablePromise()
  const inputRef = useRef(null)
  const [attributes, setAttributes] = useState([])
  const [selectedpropeties, setSelectedpropeties] = useState<IAttributes>({
    attributes: [],
    fields: []
  })

  const [filterdList, updateFilterdList] = useState<any>([])

  const { companyId } = useParams<ParamTypes>()

  useEffect(() => {
    if (aside.category) {
      if (aside.category === 'attributes') {
        updateFilterdList(attributes)
      } else {
        updateFilterdList(state.bookingModule[aside.category].list)
      }
    }
  }, [aside.category, attributes, state.bookingModule])

  useEffect(() => {
    if (state.user.accessToken) {
      cancellablePromise(axios(`${baseApiURL()}/attributes`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      })
        .then((result) => {
          setAttributes(result.data.records.filter((item: any) => item.category !== 'BIGCAR' && item.status === 'ACTIVE'))
        }).catch((err) => {
          toast(err.response.data.message)
        }))
      if (state.user.companyId) {
        cancellablePromise(axios(`${baseApiURL()}/companies/${companyId}/booking_module`, {
          headers: {
            Authorization:
              `Bearer ${state.user.accessToken}`
          }
        })
          .then((result) => {
            setLoading(false)
            setReferenceName(result.data.referenceLabel)
            setSelectedpropeties({ attributes: result.data.attributesFields, fields: result.data.staticFields })
          }).catch((err) => {
            toast(err.response.data.message)
          }))
      }
    }
  }, [cancellablePromise, companyId, state.user.accessToken, state.user.companyId])

  useEffect(() => {
    if (state.user.accessToken && state.company.id !== Number(companyId)) {
      cancellablePromise(axios(`${baseApiURL()}/companies/${companyId}`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      }).then((result: any) => {
        dispatch({ type: 'SET_COMPANY', company: result.data })
      }).catch((err: any) => {
        toast(err.response.data.message)
      }))
    }
  }, [cancellablePromise, companyId, dispatch, state.company.id, state.user.accessToken])

  const updateBookingModule = () => {
    setButtonLoading(true)
    axios.put(`${baseApiURL()}/companies/${companyId}/booking_module`, {
      ...selectedpropeties,
      referenceLabel: referenceName
    }, {
      headers: {
        Authorization: `Bearer ${state.user.accessToken}`
      }
    }).then(() => {
      setButtonLoading(false)
      history.goBack()
    }).catch((err: any) => {
      setLoading(true)
      toast(err.response.data.message)
    })
  }

  const close = () => {
    setActive(false)
    setTimeout(function () {
      toggleAside({ isShown: false, category: null, type: null })
    }, 250)
  }

  const filterList = (category) => (value) => {
    if (category === 'attributes') {
      updateFilterdList(value ? attributes.filter(attribute => attribute.description.toLowerCase().includes(value.toLowerCase())) : attributes)
    } else {
      updateFilterdList(value ? state.bookingModule[category].list.filter(field => field.description.toLowerCase().includes(value.toLowerCase())) : state.bookingModule[category].list)
    }

  }

  const openAside = (category: ICategory, type: IType) => {
    toggleAside({ isShown: true, category, type })
    setTimeout(function () {
      setActive(true)
    }, 100)
  }

  const toggleIsRequired = (type: string, code: string) => (checked: boolean) => {
    const attributes: IAttributes = { ...selectedpropeties }
    const item = attributes[type].find(item => item.code === code)
    item.required = checked
    setSelectedpropeties(attributes)
  }

  const handleToggle = (propety: Ipropeties, category: string, checked: boolean, required: boolean) => {
    const propeties: IAttributes = { ...selectedpropeties }
    if (checked) {
      if (aside.type === 'fields') {
        propeties.fields.push({ required, code: propety.code, category })
      } else {
        propeties.attributes.push({ id: propety.id, description: propety.description, code: propety.code, required })
      }
      setSelectedpropeties(propeties)
    } else {
      const i = propeties[aside.type].findIndex((item: Ipropeties) => item.code === propety.code)
      propeties[aside.type].splice(i, 1)
      setSelectedpropeties(propeties)
    }
  }

  const renderAside = (category: string, type: string) => {
    let title;
    if (category === 'attributes') {
      title = 'Egenskaber'
    } else {
      title = state.bookingModule[category].name
    }

    const categories = {
      attributes: 'Egenskaber',
      detailFields: 'Tur detaljer',
      customerFields: 'Kundeinformationer'
    }
    return (
      <aside className={`${styles.aside} ${styles.animate} ${isActive ? styles.active : ''}`}>
        <header className={styles.asideHeader}>
          <h3>{title}</h3>
          <span className={styles.closeIcon} onClick={close}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </span>
        </header>
        <div className={styles.container}>
          <Input handleInputChange={() => filterList(aside.category)} modifiers='tw-mb-3' name='search' type='text' placeholder={`Søg ${categories[aside.category]}`} />
          <ul className={styles.list}>
            {filterdList.map((item: Ipropeties, index: number) => {
              return (
                <li key={index} className={styles.listItem}>
                  <ToggleSwitch
                    checked={category === 'attributes' ? !!selectedpropeties[type].find(propety => propety.id === item.id) : !!selectedpropeties[type].find(propety => propety.code === item.code)}
                    onChange={(checked: boolean) => handleToggle(item, item.category, checked, item.required)}
                    label={`<span>${item.code === 'RE' ? referenceName : item.description}</span> <span class=${styles.code}>${item.code}</span>`}
                    readonly={item.required}
                  />
                </li>
              )
            })}
          </ul>
        </div>
      </aside>
    )
  }


  const detailFields = selectedpropeties.fields.filter((item) => item.category === 'DETAILS')
  const customerFields = selectedpropeties.fields.filter((item) => item.category === 'CUSTOMER')

  return (
    <>
      <Header />
      <SubHeader loading={loading} backPath={location.state.backPath ? location.state.backPath : '/companies'} title={
        <>
          <svg className='arrow-icon' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          <span className='color-gray tw-font-normal'>{location.state.from}</span> <span className='tw-mx-3 color-gray tw-font-normal'>/</span> <span className='text-black text-bold'>Bookingmodul</span>
        </>
      }>
        <Button modifiers='tw-ml-auto' type='primary' loading={buttonLoading} label='Gem ændringer' handleClick={updateBookingModule} />
      </SubHeader>
      <div className='tw-flex tw-flex-auto'>
        <aside className={styles.aside}>
          {loading ?
            <div className='tw-px-6'>
              <div className='label-loading tw-mb-4 tw-mt-8' />
              <div className='box-loading' />
            </div>
            :
            <div className={styles.section}>
              <header className={styles.sectionHeader}>
                <h6 className={styles.sectionTitle}>Egenskaber</h6>
                <span className={`${styles.addButton} ${aside.category === 'attributes' ? styles.addButtonActive : ''}`} onClick={() => openAside('attributes', 'attributes')}>
                  <svg className='tw-w-5' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                </span>
              </header>
              <div className={styles.sectionContent}>
                {selectedpropeties.attributes.length > 0
                  ? <ul> {selectedpropeties.attributes.map((item, index) =>
                    <li className={`${styles.listItem} tw-flex`} key={index}>
                      <span>{item.description}</span>
                      <Checkbox label='Påkrævet' checked={item.required} name={item.description} modifiers='tw-ml-auto' handleChange={() => toggleIsRequired('attributes', item.code)} />
                    </li>
                  )}
                  </ul> : <p className={styles.description}>Ingen egenskaber endnu</p>}
              </div>
            </div>}
          {loading ?
            <div className='tw-px-6'>
              <div className='label-loading label-loading--small tw-mb-4 tw-mt-8' />
              <div className='box-loading' />
            </div>
            :
            <div className={styles.section}>
              <header className={styles.sectionHeader}>
                <h3 className={styles.sectionTitle}>Tur detaljer</h3>
                <span className={`${styles.addButton} ${aside.category === 'detailFields' ? styles.addButtonActive : ''}`} onClick={() => openAside('detailFields', 'fields')}>
                  <svg className='tw-w-5' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                </span>
              </header>
              <div className={styles.sectionContent}>
                {detailFields && detailFields.length > 0
                  ? <ul> {state.bookingModule.detailFields.list.filter((propety) => detailFields.find((item) => propety.code === item.code)).map((item, index) =>
                    <li className={`${styles.listItem} tw-flex`} key={index}>
                      <span>{item.description}</span>
                      {!item.required && <Checkbox label='Påkrævet' checked={selectedpropeties.fields.find(field => field.code === item.code) && selectedpropeties.fields.find(field => field.code === item.code).required} name={item.description} modifiers='tw-ml-auto' handleChange={() => toggleIsRequired('fields', item.code)} />}
                    </li>
                  )}
                  </ul>
                  : <p className={styles.description}>Ingen tur detaljer endnu</p>}
              </div>
            </div>}
          {loading ?
            <div className='tw-px-6'>
              <div className='label-loading tw-mb-4 tw-mt-8' />
              <div className='box-loading' />
            </div>
            : <div className={styles.section}>
              <header className={styles.sectionHeader}>
                <h3 className={styles.sectionTitle}>Kundeinformationer</h3>
                <span className={`${styles.addButton} ${aside.category === 'customerFields' ? styles.addButtonActive : ''}`} onClick={() => openAside('customerFields', 'fields')}>
                  <svg className='tw-w-5' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                </span>
              </header>
              <div className={styles.sectionContent}>
                {customerFields && customerFields.length > 0
                  ? <ul> {state.bookingModule.customerFields.list.filter((propety) => customerFields.find((item) => propety.code === item.code)).map((item, index) =>
                    <li className={`${styles.listItem} tw-flex`} key={index}>
                      {!focused && item.code === 'RE' && <span>{referenceName}</span>}
                      {item.code !== 'RE' && <span>{item.description}</span>}
                      {focused && item.code === 'RE' && <input value={referenceName} onChange={(e) => setReferenceName(e.target.value)} ref={inputRef} onBlur={() => setFocused(false)} />}
                      {item.code === 'RE' && !focused && <button type='button' onClick={() => { setFocused(true); setTimeout(() => inputRef.current.focus(), 0); }} className={styles.editButton}><svg xmlns="http://www.w3.org/2000/svg" className="tw-h-5 tw-w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                      </svg></button>}

                      {!item.required && <Checkbox label='Påkrævet' checked={selectedpropeties.fields.find(field => field.code === item.code) && selectedpropeties.fields.find(field => field.code === item.code).required} name={item.description} modifiers='tw-ml-auto' handleChange={() => toggleIsRequired('fields', item.code)} />}
                    </li>
                  )}
                  </ul>
                  : <p className={styles.description}>Ingen kundeinformationer endnu</p>}
              </div>
            </div>}
        </aside>
        <main className={styles.main}>
          {loading ?
            <div className='input-field-loading tw-w-full tw-mb-12' /> :
            <>
              <legend className={styles.label}>Egenskaber</legend>
              <div className={`${styles.attributes} tw-py-2`}>
                <ul className='tw-flex tw-flex-auto tw-items-center tw-flex-wrap'>
                  {selectedpropeties.attributes.filter(item => item.required)
                    .map((item, index) => <li className={styles.attributeItem} key={index}>
                      <span className='tw-w-4 tw-h-4 tw-mr-2'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg></span>
                      <span>{item.description}</span></li>)}
                </ul>
              </div>
            </>}
          {loading ?
            <div className={styles.boxLoadingBig} /> :
            <>
              <legend className={styles.label}>Tur detaljer</legend>
              <div className={styles.attributes}>
                {state.bookingModule.detailFields.list.filter((propety) => detailFields.find((item) => propety.code === item.code))
                  .map((item, index) => {
                    return <Input
                      readOnly={true}
                      placeholder={item.placeholder}
                      key={index} modifiers={`tw-ml-3 tw-mb-3 ${item.modifier ? item.modifier : ''} `}
                      type='text'
                      IconRight={item.IconRight}
                      countryCode={item.countryCode}
                      label={`
                  ${item.inputLabel || item.description}
                  ${detailFields.find((field) => field.code === item.code).required ? '*' : ''} `}
                      name={item.name} />
                  })}
              </div>
            </>}
          {loading ?
            <div className='input-field-loading tw-w-full tw-mb-12' /> :
            <>
              <legend className={styles.label}>Tilvalg</legend>
              <div className={styles.attributes}>
                {selectedpropeties.attributes.filter(attribute => !attribute.required)
                  .map((item, index) => <Button modifiers='tw-ml-3' label={item.description} type='addon' key={index} />)}
              </div>
              <legend className={styles.label}>Kundeinformationer</legend>
              <div className={styles.attributes}>
                {state.bookingModule.customerFields.list.filter((propety) => customerFields.find((item) => propety.code === item.code))
                  .map((item, index) => {
                    return <Input
                      readOnly={true}
                      placeholder={item.placeholder}
                      key={index} modifiers={`tw-ml-3 tw-mb-3 ${item.modifier ? item.modifier : ''} `}
                      type='text'
                      IconRight={item.IconRight}
                      countryCode={item.countryCode}
                      label={`
                  ${item.code === 'RE' ? referenceName : item.inputLabel || item.description}
                  ${customerFields.find((field) => field.code === item.code).required ? '*' : ''} `}
                      name={item.name} />
                  })}
              </div>
            </>}
        </main>
        {aside.isShown && renderAside(aside.category, aside.type)}
      </div>
    </>
  )
}

export default BookingModule
